module.exports = __webpack_public_path__ + "static/media/GamingActive.26519b59.svg";